module.exports = __webpack_public_path__ + "img/DSC09106_redimensionner.ffa47720.webp";